import { render, staticRenderFns } from "./client-batches.vue?vue&type=template&id=1e3e248d&"
import script from "./client-batches.vue?vue&type=script&lang=ts&"
export * from "./client-batches.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports